import React from "react";
import classNames from "classnames";
import "./index.less";
export default function Badge(props) {
    var value = props.value, icon = props.icon, _a = props.size, size = _a === void 0 ? 16 : _a, _b = props.showZero, showZero = _b === void 0 ? false : _b, className = props.className, style = props.style, _c = props.dot, dot = _c === void 0 ? false : _c, _d = props.dotSize, dotSize = _d === void 0 ? 10 : _d;
    var isNumberProvided = typeof value === "number";
    var isZeroHidden = isNumberProvided && value === 0 && !showZero;
    if (!icon && !isNumberProvided && !dot)
        return null;
    if (isZeroHidden)
        return null;
    // dot 模式：仅展示小红点，无内容
    if (dot) {
        var dotStyle = {
            width: dotSize,
            height: dotSize
        };
        return (React.createElement("span", { className: classNames("j-badge", "j-badge--dot", className), style: style },
            React.createElement("span", { className: "j-badge__content", style: dotStyle })));
    }
    var isOverflow = isNumberProvided && Number(value) > 99; // 百位及以上
    var isTwoDigits = isNumberProvided && Number(value) >= 10 && Number(value) <= 99; // 十位
    var displayText = isNumberProvided ? (isOverflow ? "99+" : String(value)) : undefined;
    var diameter = size;
    var baseStyle = {
        width: diameter,
        height: diameter
    };
    return (React.createElement("span", { className: classNames("j-badge", {
            "j-badge--ten": isTwoDigits,
            "j-badge--hundred": isOverflow
        }, className), style: style },
        React.createElement("span", { className: "j-badge__content", style: baseStyle }, icon ? icon : displayText)));
}
;
//# sourceMappingURL=index.js.map